// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { Buliding } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = { Buliding };

// ==============================|| MENU ITEMS - NCVET COMPLAINCE ||============================== //

/** Hide NCVET-only items (e.g. Questions) when the org is not NCVET-compliant. */
export function filterBatchesMenuByNcvetCompliance(menu: NavItemType, ncvetCompliance: boolean): NavItemType {
  if (ncvetCompliance) return menu;
  const collapse = menu.children?.[0];
  if (!collapse?.children?.length) return menu;
  return {
    ...menu,
    children: [
      {
        ...collapse,
        children: collapse.children.filter((item) => !item.requiresNcvetCompliance)
      }
    ]
  };
}

/** Hide Question Bank + Rubrics when the signed-in role is not allowed by org.ncvetQuestionBankAccess. */
export function filterNcvetQuestionBankMenuByOrgAccess(menu: NavItemType, canManageQuestionBank: boolean): NavItemType {
  if (canManageQuestionBank) return menu;
  const collapse = menu.children?.[0];
  if (!collapse?.children?.length) return menu;
  return {
    ...menu,
    children: [
      {
        ...collapse,
        children: collapse.children.filter((item) => item.id !== 'ncvetQuestions' && item.id !== 'ncvetRubrics')
      }
    ]
  };
}

const Batches: NavItemType = {
  id: 'NCVETComplaince',
  type: 'group',
  icon: icons.Buliding,
  name: 'NCVETComplaince',
  children: [
    {
      icon: icons.Buliding,
      id: 'NCVETComplaince',
      title: <FormattedMessage id="NCVET Complaince" />,
      type: 'collapse',
      children: [
        {
          icon: icons.icon1,
          id: 'skillSector',
          title: <FormattedMessage id="Skill Sector" />,
          type: 'item',
          name: 'SkillSector',
          url: '/skillSector',
          rootOnly: true
        },
        {
          icon: icons.icon1,
          id: 'performanceCriteria',
          title: <FormattedMessage id="Performance Criteria" />,
          type: 'item',
          name: 'PerformanceCriteria',
          url: '/performanceCriteria',
          rootOnly: true
        },
        {
          icon: icons.icon1,
          id: 'nos',
          title: <FormattedMessage id="NOS" />,
          type: 'item',
          name: 'NOS',
          url: '/nos',
          rootOnly: true
        },
        {
          icon: icons.icon1,
          id: 'qualificationpack',
          title: <FormattedMessage id="Qualification Pack" />,
          type: 'item',
          name: 'QualificationPack',
          url: '/qualificationpack',
          rootOnly: true
        },
        {
          icon: icons.icon1,
          id: 'ncvetRubrics',
          title: <FormattedMessage id="Rubrics" defaultMessage="Rubrics" />,
          type: 'item',
          name: 'NcvetRubrics',
          url: '/rubrics',
          requiresNcvetCompliance: true
        },
        {
          icon: icons.icon1,
          id: 'ncvetQuestions',
          title: <FormattedMessage id="Question Bank" defaultMessage="Question Bank" />,
          type: 'item',
          name: 'NcvetQuestions',
          url: '/question-bank',
          requiresNcvetCompliance: true
        },
        {
          icon: icons.icon1,
          id: 'Batch',
          title: <FormattedMessage id="Batches" />,
          type: 'item',
          name: 'Batches',
          url: '/batch'
        }
      ]
    }
  ]
};

export default Batches;
  